// Top-up packs action: GET /v1/billing/topup-packs
// Real-money purchases flow through the Stripe Checkout slice
// (./checkout.js) — this slice only fetches the catalogue.
const action = "BILLING_TOPUP";

export const PACKS_REQUEST  = action + '_PACKS_REQUEST';
export const PACKS_RESPONSE = action + '_PACKS_RESPONSE';
export const PACKS_FAILURE  = action + '_PACKS_FAILURE';

export const fetchPacks   = ()      => ({ type: PACKS_REQUEST });
export const packsSuccess = (packs) => ({ type: PACKS_RESPONSE, payload: packs });
export const packsFailure = (error) => ({ type: PACKS_FAILURE,  payload: error });
